module.exports = {
  "version": "0.25.0"
};


//////////////////
// WEBPACK FOOTER
// ../~/axios/lib/env/data.js
// module id = 54
// module chunks = 0 1